var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:bevel;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-more-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.02,
    cy: 4.19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.98,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.02,
    cy: 19.81,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/Action.6d08c8ed0d30cb5a40b74581eb5c6ebd.svg";
export { ForwardRef as ReactComponent };